import styled from 'styled-components';

export const CardWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-column-gap: 16px;
	grid-row-gap: 16px;

	@media (max-width: 992px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;
